import { initI18n } from '@kostbar/i18n'

// Import app-specific translations
import deApp from './locales/de/app.json'
import deNav from './locales/de/nav.json'
import deToast from './locales/de/toast.json'
import deDashboard from './locales/de/dashboard.json'
import deProducts from './locales/de/products.json'
import deCategories from './locales/de/categories.json'
import deRestaurants from './locales/de/restaurants.json'
import deUsers from './locales/de/users.json'
import deCustomers from './locales/de/customers.json'
import deRoles from './locales/de/roles.json'
import deMenus from './locales/de/menus.json'
import deInventory from './locales/de/inventory.json'
import deInventoryCount from './locales/de/inventory-count.json'
import deInventoryDeliveries from './locales/de/inventory-deliveries.json'
import deTransactions from './locales/de/transactions.json'
import dePricing from './locales/de/pricing.json'
import deProfile from './locales/de/profile.json'
import deLogin from './locales/de/login.json'
import deUi from './locales/de/ui.json'
import deBundles from './locales/de/bundles.json'
import deEdges from './locales/de/edges.json'
import deStaff from './locales/de/staff.json'
import deVouchers from './locales/de/vouchers.json'
import dePosLayout from './locales/de/pos-layout.json'
import deWebbillSync from './locales/de/webbill-sync.json'
import deReports from './locales/de/reports.json'
import deIntegrations from './locales/de/integrations.json'
import dePurchaseOrders from './locales/de/purchase-orders.json'
import enApp from './locales/en/app.json'
import enNav from './locales/en/nav.json'
import enToast from './locales/en/toast.json'
import enDashboard from './locales/en/dashboard.json'
import enProducts from './locales/en/products.json'
import enCategories from './locales/en/categories.json'
import enRestaurants from './locales/en/restaurants.json'
import enUsers from './locales/en/users.json'
import enCustomers from './locales/en/customers.json'
import enRoles from './locales/en/roles.json'
import enMenus from './locales/en/menus.json'
import enInventory from './locales/en/inventory.json'
import enInventoryCount from './locales/en/inventory-count.json'
import enInventoryDeliveries from './locales/en/inventory-deliveries.json'
import enTransactions from './locales/en/transactions.json'
import enPricing from './locales/en/pricing.json'
import enProfile from './locales/en/profile.json'
import enLogin from './locales/en/login.json'
import enUi from './locales/en/ui.json'
import enBundles from './locales/en/bundles.json'
import enEdges from './locales/en/edges.json'
import enStaff from './locales/en/staff.json'
import enVouchers from './locales/en/vouchers.json'
import enPosLayout from './locales/en/pos-layout.json'
import enWebbillSync from './locales/en/webbill-sync.json'
import enReports from './locales/en/reports.json'
import enIntegrations from './locales/en/integrations.json'
import enPurchaseOrders from './locales/en/purchase-orders.json'

// Get stored language preference or default to German
const storedLanguage = localStorage.getItem('preferred-language') ?? 'de'

const backofficeResources = {
  de: {
    app: deApp,
    nav: deNav,
    toast: deToast,
    dashboard: deDashboard,
    products: deProducts,
    categories: deCategories,
    restaurants: deRestaurants,
    users: deUsers,
    customers: deCustomers,
    roles: deRoles,
    menus: deMenus,
    inventory: deInventory,
    'inventory-count': deInventoryCount,
    'inventory-deliveries': deInventoryDeliveries,
    transactions: deTransactions,
    pricing: dePricing,
    profile: deProfile,
    login: deLogin,
    ui: deUi,
    bundles: deBundles,
    edges: deEdges,
    staff: deStaff,
    vouchers: deVouchers,
    'pos-layout': dePosLayout,
    'webbill-sync': deWebbillSync,
    reports: deReports,
    integrations: deIntegrations,
    'purchase-orders': dePurchaseOrders,
  },
  en: {
    app: enApp,
    nav: enNav,
    toast: enToast,
    dashboard: enDashboard,
    products: enProducts,
    categories: enCategories,
    restaurants: enRestaurants,
    users: enUsers,
    customers: enCustomers,
    roles: enRoles,
    menus: enMenus,
    inventory: enInventory,
    'inventory-count': enInventoryCount,
    'inventory-deliveries': enInventoryDeliveries,
    transactions: enTransactions,
    pricing: enPricing,
    profile: enProfile,
    login: enLogin,
    ui: enUi,
    bundles: enBundles,
    edges: enEdges,
    staff: enStaff,
    vouchers: enVouchers,
    'pos-layout': enPosLayout,
    'webbill-sync': enWebbillSync,
    reports: enReports,
    integrations: enIntegrations,
    'purchase-orders': enPurchaseOrders,
  },
}

const backofficeNamespaces = Object.keys(backofficeResources.de)

// Initialize i18next with shared + app-specific resources
initI18n({
  lng: storedLanguage,
  debug: import.meta.env.DEV,
  additionalResources: backofficeResources,
  additionalNamespaces: backofficeNamespaces,
})
